import React from 'react';
import { motion } from 'framer-motion';
import ContactInfoCards from '../components/ContactInfoCards';
import InteractiveMap from '../components/InteractiveMap';
import ContactForm from '../components/ContactForm';
import ContactFAQ from '../components/ContactFAQ';

const ContactPage = () => {
  return (
    <main className="pt-20 lg:pt-28 pb-20 bg-gray-50/50">
      <div className="container mx-auto px-4">
        {/* Page Header */}
        <motion.div 
          className="text-center max-w-3xl mx-auto mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-block px-4 py-1 rounded-full bg-blue-100 text-blue-900 font-medium text-sm mb-4">
            Contact Us
          </span>
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Let's Start a Conversation
          </h1>
          <p className="text-xl text-gray-600">
            Whether you have a question, a project in mind, or just want to say hello, we're here to help.
          </p>
        </motion.div>

        <ContactInfoCards />

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto items-start mb-24">
          <InteractiveMap />
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <ContactForm />
          </motion.div>
        </div>
      </div>
      
      <ContactFAQ />
    </main>
  );
};

export default ContactPage;
